module.exports = __webpack_public_path__ + "static/media/VIP_Hour_Tile_1@3x.dd57f882.png";